import { svg } from "../svg";

export const FallenVaultLogo = svg`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360 72">
  <title>Fallen Vault</title>
  <rect x="2" y="4" width="64" height="64" rx="14" fill="#1a0b0b" stroke="#ff4444" stroke-opacity=".35"/>
  <path d="m47 9 9 9-25 25-9-9z" fill="#ff4444"/>
  <path d="m20 32 13 13-5 5-13-13z" fill="#fff4f4"/>
  <path d="m18 43 8 8-6 6-8-8z" fill="#ff4444"/>
  <path d="m15 48 4 4-7 7-4-4z" fill="#fff4f4"/>
  <text x="82" y="48" fill="#fff4f4" font-family="ui-monospace, SFMono-Regular, Consolas, monospace" font-size="30" font-weight="600" letter-spacing="-1">FALLEN VAULT</text>
</svg>
`;
